import { useContext, useEffect } from "react";
import { Col, Form, Row } from "react-bootstrap";
import CreateOrderContext from "../../context/createOrder/";
import { capitalizeFirstLetter } from "../../hooks/helpers/helpers";
import { usePrices } from "../../context/prices/PricesContext";
import RegelBedrag, { RegelAantal } from "./RegelBedrag";

/**
 * Bovenaansluiting. Materiaal en kleur volgen de treden; het type is alleen
 * registratie en beïnvloedt de prijs niet.
 *
 * Aantal en bedrag komen uit de calculatie van de backend.
 */
const TopConnection = () => {
  const { stairMaterial, stairColor, topConnectionCode } =
    useContext(CreateOrderContext);

  const { getMaterialName, connectionTypes } = usePrices();

  // Default het bovenaansluiting-type naar het eerste beschikbare type.
  useEffect(() => {
    if (!topConnectionCode.value && connectionTypes.length > 0) {
      topConnectionCode.set(connectionTypes[0].code);
    }
    // eslint-disable-next-line
  }, [connectionTypes.length]);

  const selectedType = connectionTypes.find(
    (t) => t.code === topConnectionCode.value
  );

  return (
    <>
      <Row className="mb-2">
        <Form.Group as={Col} xs={12} md={6} className="auth-input ">
          <Form.Label>Type bovenaansluiting</Form.Label>
          <select
            className="select"
            style={{ padding: "8px 4px", position: "inherit" }}
            value={topConnectionCode.value}
            onChange={(e) => topConnectionCode.set(e.target.value)}
          >
            {connectionTypes.length === 0 && <option value="">Geen types</option>}
            {connectionTypes.map((t) => (
              <option key={t.code} value={t.code} className="select-item">
                {t.displayName}
              </option>
            ))}
          </select>
        </Form.Group>

        <Col xs={12} md={6} className="d-flex align-items-end">
          {selectedType?.imageUrl ? (
            <img
              src={selectedType.imageUrl}
              alt={selectedType.displayName}
              style={{
                maxHeight: 90,
                maxWidth: "100%",
                objectFit: "contain",
                border: "1px solid #e2e8f0",
                borderRadius: 4,
                padding: 2,
              }}
            />
          ) : (
            <div
              style={{
                height: 90,
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#94a3b8",
                fontSize: "0.8rem",
                border: "1px dashed #cbd5e1",
                borderRadius: 4,
              }}
            >
              Foto volgt
            </div>
          )}
        </Col>
      </Row>

      <Row>
        <Form.Group as={Col} xs={6} md={3} className="auth-input ">
          <Form.Label>Materiaal Bovenaansluiting</Form.Label>
          <Form.Control
            type={"text"}
            disabled={true}
            value={getMaterialName(stairMaterial.value)}
          />
        </Form.Group>

        <Form.Group as={Col} xs={6} md={3} className="auth-input ">
          <Form.Label>Kleur</Form.Label>
          <Form.Control
            type={"text"}
            disabled={true}
            value={capitalizeFirstLetter(stairColor.value)}
          />
        </Form.Group>

        {/* Altijd één bovenaansluiting: een strip plus een hoeklijn. */}
        <RegelAantal code="bovenaansluiting-strip" />
        <RegelBedrag code={["bovenaansluiting-strip", "bovenaansluiting-hoeklijn"]} />
      </Row>
    </>
  );
};

export default TopConnection;
